import { i18n } from '@/shared/i18n';

// Functions, not consts: resolving at call time is what lets the copy follow a
// language change instead of freezing at import.

/** Step labels shown in the Content Test wizard's step tracker. */
export const contentTestSteps = (): string[] => [
  i18n.t('contentTest:contentTest.constants.setup'),
  i18n.t('contentTest:contentTest.constants.run'),
];

/** Title shown in the Content Test wizard configuration panel header. */
export const contentTestWizardTitle = (): string =>
  i18n.t('contentTest:contentTest.constants.contentTestConfiguration');
